"use client";

import { useIsPresentationTool } from "next-sanity/hooks";

/**
 * "Vorschau verlassen" button — shown when Draft Mode is active *outside*
 * the Presentation Tool iframe (so editors can return to the published site).
 */
export function DisableDraftMode() {
  // Inside Presentation the Studio controls the session — hide the button.
  // `useIsPresentationTool()` is `null` until resolved; only render when false.
  if (useIsPresentationTool() !== false) return null;

  return (
    <a
      href="/api/draft-mode/disable"
      className="fixed bottom-4 left-4 z-50 rounded-full bg-black px-4 py-2 text-sm font-medium text-white shadow-lg"
    >
      Vorschau verlassen
    </a>
  );
}
